/* @flow */

import * as React from 'react';

import classnames from 'classnames';

import {RadioGroupContext} from './radio-group';

import '../checkbox/checkbox-button.module.css';

type Props = {
    disabled?: boolean,
    value: string,
    isLarge?: boolean,
    children?: React.Node,
};

export class RadioButton extends React.Component<Props> {
    render() {
        const styleNames = classnames('input-button', {
            'is-large': this.props.isLarge,
        });

        return (
            <RadioGroupContext.Consumer>
                {({name, selectedValue, onChange}) => {
                    const checked = this.props.value === selectedValue;
                    const radioId = `${name}-${this.props.value}`;

                    return (
                        <div styleName={styleNames}>
                            <input
                                id={radioId}
                                name={name}
                                type='radio'
                                role='radio'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(e) => this.handleChange(e, onChange)}
                            />
                            <label htmlFor={radioId}>{this.props.children}</label>
                        </div>
                    );
                }}
            </RadioGroupContext.Consumer>
        );
    }

    handleChange = (e: SyntheticInputEvent<*>, onChange: Function) => {
        e.stopPropagation();

        onChange(this.props.value);
    };
}
